enum ArticleAudioType {
  INTERNAL = 0,
  EXTERNAL = 1,
  BOTH = 2,
}

export default ArticleAudioType;
